import { api } from '@jurnee/common/src/browser/Api';
import { PartnerLoginResponse, TokenCompletionBody, TokenCompletionResponse } from '@jurnee/common/src/dtos/auth';

export async function sendMagicLink(email: string) {
  return api.post('/auth/magic-link', { email });
}

export async function completeMagicLink(token: string): Promise<PartnerLoginResponse> {
  return api.post(`/auth/magic-link/${token}/complete`);
}

export async function completeToken(payload: TokenCompletionBody): Promise<TokenCompletionResponse> {
  return api.post('/auth/token/complete', payload);
}